import { NavLink } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section className='relative px-6 py-10 overflow-hidden bg-white md:py-10 md:px-8'>
      {/* subtle background accent */}

      <div className='absolute inset-0 flex items-center justify-center pointer-events-none'>
        <div
          className='
          w-[600px]
          h-[600px]
          rounded-full
          bg-gradient-to-br
          from-[#E6F4EF]
          via-transparent
          to-[#F3FBF8]
          blur-3xl
          opacity-70
          '
        />
      </div>

      <div className='relative max-w-4xl mx-auto text-center'>
        {/* label */}

        <ScrollReveal>
          <p
            className='
            mb-6
            text-[11px]
            tracking-[0.28em]
            text-[#2F8F6F]
            uppercase
            font-medium
            '
          >
            {t('cta.label')}
          </p>
        </ScrollReveal>

        {/* title */}

        <ScrollReveal delay={0.1}>
          <h2
            className='
            font-semibold
            leading-tight
            mb-7

            text-[38px]
            sm:text-[52px]
            md:text-[64px]
            lg:text-[72px]

            tracking-tight
            '
          >
            {t('cta.title1')}

            <br />

            <span className='text-[#2F8F6F]'>{t('cta.title2')}</span>
          </h2>
        </ScrollReveal>

        {/* description */}

        <ScrollReveal delay={0.2}>
          <p className='max-w-xl mx-auto mb-12 text-base leading-relaxed text-neutral-600 md:text-lg'>
            {t('cta.desc')}
          </p>
        </ScrollReveal>

        {/* buttons */}

        <ScrollReveal delay={0.3}>
          <div className='flex flex-col justify-center gap-4 sm:flex-row'>
            {/* PRIMARY BUTTON */}

            <NavLink
              to='/portfolio/graphic'
              className='
              w-full
              sm:w-auto
              px-9
              py-4
              rounded-xl
              font-medium
              text-white
              bg-[#2F8F6F]

              transition
              duration-300

              hover:-translate-y-[1px]
              hover:shadow-lg
              hover:bg-[#27785D]

              text-center
              '
            >
              {t('cta.buttons.portfolio')}
            </NavLink>

            {/* SECONDARY BUTTON */}

            <a
              href='https://kmong.com'
              target='_blank'
              rel='noreferrer'
              className='
              w-full
              sm:w-auto
              px-9
              py-4
              rounded-xl
              border
              border-neutral-300
              text-neutral-800

              transition
              duration-300

              hover:border-[#2F8F6F]
              hover:text-[#2F8F6F]
              hover:-translate-y-[1px]

              text-center
              '
            >
              {t('cta.buttons.kmong')}
            </a>

            {/* SECONDARY BUTTON */}

            <a
              href='https://instagram.com/tomado_d'
              target='_blank'
              rel='noreferrer'
              className='
              w-full
              sm:w-auto
              px-9
              py-4
              rounded-xl
              border
              border-neutral-300
              text-neutral-800

              transition
              duration-300

              hover:border-[#2F8F6F]
              hover:text-[#2F8F6F]
              hover:-translate-y-[1px]

              text-center
              '
            >
              {t('cta.buttons.instagram')}
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default CTA;
